import { LocalizedText, useIsTextKey } from '@mews/framework';

const TooltipComponent = ({ tooltip }: { tooltip?: Mews.TextKey | React.ReactNode }) => {
    const isTextKey = useIsTextKey();
    return isTextKey(tooltip) ? <LocalizedText textKey={tooltip} /> : <>{tooltip}</>;
};

export const getTooltipValue = (tooltip?: Mews.TextKey | React.ReactNode) => {
    if (!tooltip) {
        return null;
    }

    return <TooltipComponent tooltip={tooltip} />;
};
